export interface IDeveloperSettings {
    enabled: boolean;
    vendorName: string;
}

export class DeveloperSettings implements IDeveloperSettings {
    enabled: boolean;
    vendorName: string;

    constructor(settings?: Partial<IDeveloperSettings>) {
        this.enabled = settings?.enabled ?? false;
        this.vendorName = settings?.vendorName ?? "";
    }
}
